import {Component, OnInit} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']

})

export class AppComponent implements OnInit {
    public isCollapsed = true;

    constructor(public router: Router) {
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            this.toTop();
        });
    }

    public toTop() {
        window.scrollTo(0, 0);
    }
}



// WEBPACK FOOTER //
// /media/webdesign/5E0ECC7B0ECC4E29/www/leasytool/src/app/app.component.ts